export default __webpack_public_path__ + "static/media/G.b571eb82.png";